export default __webpack_public_path__ + "static/media/shutterstock_1935754660_FAQS_small.dd9e4459.webp";